import { render, staticRenderFns } from "./GenericButton.vue?vue&type=template&id=910ab7be&"
import script from "./GenericButton.vue?vue&type=script&lang=ts&"
export * from "./GenericButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports